import { NavLink, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { logout } from '../services/auth';
import './AppShell.css';

const NAV_ITEMS = [
  { to: '/dashboard', label: 'Dashboard' },
  { to: '/clients',   label: 'Clients' },
  { to: '/contracts', label: 'Contracts' },
  { to: '/invoices',  label: 'Invoices' },
  { to: '/settings',  label: 'Settings' },
];

const PAGE_TITLES = {
  '/dashboard': 'Dashboard',
  '/clients':   'Clients',
  '/contracts': 'Contracts',
  '/invoices':  'Invoices',
  '/settings':  'Settings',
};

export default function AppShell() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const title = PAGE_TITLES[pathname] ?? 'Admin';

  function handleLogout() {
    logout();
    navigate('/login', { replace: true });
  }

  return (
    <div className="shell">
      <nav className="shell-sidebar">
        <div className="shell-logo">Semper Gratus</div>
        <ul>
          {NAV_ITEMS.map(({ to, label }) => (
            <li key={to}>
              <NavLink to={to} className={({ isActive }) => isActive ? 'active' : ''}>
                {label}
              </NavLink>
            </li>
          ))}
        </ul>
        <button className="shell-logout" onClick={handleLogout}>Log out</button>
      </nav>
      <div className="shell-body">
        <header className="shell-topbar">
          <h1>{title}</h1>
        </header>
        <main className="shell-main">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
